export type StoreableItems = {
  uuid: string;
};

/** Returns whether the store succeeded or not */
export function setStorageItem<T extends keyof StoreableItems>(
  key: T,
  value: StoreableItems[T],
  storePlainString?: boolean
): boolean {
  if (typeof window === 'undefined') return false;
  try {
    const storeValue =
      storePlainString && typeof value === 'string' ? value : JSON.stringify(value);
    window.localStorage.setItem(key, storeValue);
    return true;
  } catch {
    return false;
  }
}

export function getStorageItem<T extends keyof StoreableItems>(key: T): StoreableItems[T] | null {
  // return early for SSR, instead of throwing an error
  if (typeof window === 'undefined') return null;
  try {
    const value = window.localStorage.getItem(key);
    return value === null ? value : JSON.parse(value);
  } catch {
    return null;
  }
}

export function clearStorageItem<T extends keyof StoreableItems>(key: T): void {
  try {
    window.localStorage.removeItem(key);
  } catch {
    // do nothing
  }
}
